import {StringArray} from '@src/@interfaces/types';
import {ClassOrConstructor} from '@src/@types/instantable';
import {isConstructor} from '@src/helpers/isConstructor';
import {IContainer} from '@src/@interfaces/services/Container/IContainer';

export default class Container implements IContainer {
    protected bindings: StringArray<ClassOrConstructor<any>> = {};

    bind<C>(abstract: string, concrete: ClassOrConstructor<C>): void {
        this.bindings[abstract] = concrete;
    }

    singleton<C>(abstract: string, concrete: ClassOrConstructor<C>): void {
        this.bindings[abstract] = class {
            readonly #instance: any;

            constructor(...args: any[]) {
                if (!this.#instance) {
                    if (isConstructor(concrete)) {
                        this.#instance = new concrete(...args);
                    } else {
                        this.#instance = concrete;
                    }
                }

                return this.#instance;
            }
        };
    }

    has(abstract: string): boolean {
        return abstract in this.bindings;
    }

    get<C>(abstract: string, parameters: any[] = []): C | null {
        if (!(abstract in this.bindings)) {
            return null;
        }

        const binding = this.bindings[abstract];
        if (isConstructor(binding)) {
            return new binding(...parameters);
        }

        return binding as C;
    }
}
